import UPPagination from './UPPagination';

export default UPPagination;
